export const aboutData = {
  brandName: "韩漫之家",
  tagline: "您的韩国漫画阅读乐园",
  introduction: "韩漫之家成立于2024年，是国内领先的免费韩国漫画在线阅读平台。我们致力于为广大华语漫画爱好者提供最新、最全、最优质的韩国漫画资源。从热门连载到经典完结，从恋爱言情到热血动作，韩漫之家涵盖了所有主流漫画品类，满足每一位读者的阅读需求。",
  mission: "我们的使命是打破语言的壁垒，让每一位华语读者都能轻松享受韩国漫画的魅力。我们拥有一支专业的翻译和内容团队，确保每一部漫画都能以最高质量的中文呈现给读者。",
  features: [
    {
      title: "海量资源",
      description: "收录超过500部韩国漫画，涵盖恋爱、奇幻、悬疑、动作、搞笑等十大品类，每周持续更新。",
      icon: "ri-book-open-line",
    },
    {
      title: "阅读体验",
      description: "专为漫画阅读优化的界面设计，支持滚动阅读模式，加载速度飞快，随时随地畅享阅读。",
      icon: "ri-smartphone-line",
    },
    {
      title: "高清画质",
      description: "所有漫画均提供高清画质，支持自适应分辨率，在大屏和小屏设备上都有绝佳的阅读体验。",
      icon: "ri-hd-line",
    },
    {
      title: "更新及时",
      description: "专业翻译团队保障，与韩国官方同步更新，让您第一时间阅读到最新的漫画章节。",
      icon: "ri-flashlight-line",
    },
  ],
  stats: [
    { value: "500+", label: "漫画资源" },
    { value: "200万+", label: "月活用户" },
    { value: "10万+", label: "日更新章节" },
    { value: "4.8", label: "用户评分" },
  ],
  testimonials: [
    {
      name: "王小明",
      role: "资深漫画读者",
      content: "韩漫之家的漫画资源真的很全，更新速度也很快。最重要的是完全免费，阅读体验也非常棒，已经推荐给了身边所有的朋友！",
      avatar: "https://readdy.ai/api/search-image?query=A%20friendly%20young%20Asian%20male%20portrait%20with%20warm%20smile%2C%20casual%20style%2C%20clean%20background%2C%20professional%20headshot%20quality%2C%20soft%20natural%20lighting%2C%20approachable%20expression&width=200&height=200&seq=testimonial-avatar-01&orientation=squarish",
    },
    {
      name: "李婷婷",
      role: "大学生",
      content: "自从发现了韩漫之家，每天通勤的时间都变得愉快了。漫画种类很多，界面也很干净没有乱七八糟的广告，真的是良心平台！",
      avatar: "https://readdy.ai/api/search-image?query=A%20cheerful%20young%20Asian%20female%20portrait%20with%20bright%20smile%2C%20modern%20casual%20style%2C%20clean%20background%2C%20professional%20headshot%20quality%2C%20soft%20natural%20lighting%2C%20friendly%20expression&width=200&height=200&seq=testimonial-avatar-02&orientation=squarish",
    },
    {
      name: "张浩然",
      role: "IT工程师",
      content: "作为一个程序员，我特别欣赏韩漫之家的技术体验。页面加载快，适配也好，在大屏显示器上看漫画真的太爽了！",
      avatar: "https://readdy.ai/api/search-image?query=A%20confident%20young%20Asian%20male%20portrait%20with%20glasses%2C%20smart%20casual%20style%2C%20clean%20background%2C%20professional%20headshot%20quality%2C%20soft%20natural%20lighting%2C%20trustworthy%20expression&width=200&height=200&seq=testimonial-avatar-03&orientation=squarish",
    },
  ],
  contact: {
    email: "contact@hanmanzhijia.com",
    wechat: "韩漫之家官方",
    weibo: "@韩漫之家",
    qqGroup: "88245671",
    address: "北京市朝阳区望京SOHO T2 15层",
    phone: "400-888-6789",
  },
};